import { render, staticRenderFns } from "./Burro.vue?vue&type=template&id=6d9a3ec3&scoped=true&lang=html&"
import script from "./Burro.vue?vue&type=script&lang=js&"
export * from "./Burro.vue?vue&type=script&lang=js&"
import style0 from "./Burro.vue?vue&type=style&index=0&id=6d9a3ec3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a3ec3",
  null
  
)

export default component.exports